var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76709 0.107631C8.68897 0.0346567 8.59945 -0.00470044 8.49935 0.00103915C8.39925 0.00103915 8.30973 0.0403963 8.23731 0.119111L7.64567 0.737346L9.30257 2.35017L9.89909 1.72046C9.97152 1.64748 9.99919 1.55155 9.99919 1.45069C9.99919 1.34984 9.96012 1.25391 9.8877 1.18667L8.76709 0.107631ZM0.679525 0.417569H4.76481V1.48677H1.18652C1.15234 1.48677 1.12061 1.50153 1.09782 1.52449C1.07503 1.54745 1.06038 1.57943 1.06038 1.61386V8.80556C1.06038 8.84 1.07503 8.87198 1.09782 8.89494C1.12061 8.9179 1.15234 8.93266 1.18652 8.93266H8.32438C8.35856 8.93266 8.3903 8.9179 8.41309 8.89494C8.43587 8.87198 8.45052 8.84 8.45052 8.80556V5.33803H9.51172V9.31557C9.51172 9.50497 9.43441 9.6747 9.31152 9.79851C9.18864 9.92232 9.01774 10.0002 8.8322 10.0002H0.679525C0.490723 10.0002 0.323079 9.92232 0.200195 9.79851C0.0773112 9.67552 0 9.50251 0 9.31557V1.10222C0 0.911994 0.0773112 0.743086 0.200195 0.619275C0.322266 0.495464 0.493978 0.417569 0.679525 0.417569ZM5.66569 6.15552C5.44841 6.22849 5.22461 6.29573 5.00732 6.36952C4.79004 6.4425 4.57194 6.51547 4.34896 6.58844C3.82975 6.75735 3.54574 6.85247 3.48389 6.86968C3.42285 6.8869 3.46191 6.64502 3.58968 6.13912L4.00228 4.54843L4.03646 4.51317L5.66569 6.1547V6.15552ZM4.63949 3.88182L7.19727 1.20553L8.85417 2.81262L6.2679 5.52252L4.63949 3.88182Z",
    fill: "#18A06F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBoxIcon);
export default __webpack_public_path__ + "static/media/edit-box-icon.715e684cd022b300a71d3a38d0471242.svg";
export { ForwardRef as ReactComponent };